export default __webpack_public_path__ + "static/discover-damixa--black-26336f267ab82bb5e6915f3559f3c7ba.svg";